import { state } from './state';
import { ReadOnlyCryptoProfilesManager } from './components/CryptoProfilesManager';
import { CryptoProfileButton } from './components/CryptoProfileButton';
import { getCryptoProfiles } from './state/cryptoprofiles/sagas';
import translations from './translations.json';


export * from './components/CertificateSelector';
export * from './components/CertificateSelector2';
export * from './components/UpdateCertsButton';
export * from './constants';
export * from './state/cryptoprofiles/actions';
export * from './state/certificates/actions';
export { useError, useSelectedCertificate, useCertificates } from './state/certificates';
export * from './state/sagas';

export const cryptoprofiles = {
    state,
    messaging: {
        modalTypes: {
            ReadOnlyCryptoProfilesManager,
        },
    },
    user: {
        infoButtons: [CryptoProfileButton],
        changeUserRoleSagas: [getCryptoProfiles],
    },
    environment: {
        initializationSagas: [getCryptoProfiles],
    },
    translations,
};
